export const GA_MEASUREMENT_ID = 'G-NZ7PJRQ25N';

export const initGA4 = () => {
    // Initialize dataLayer and gtag if not already done
    if (typeof window !== 'undefined') {
        (window as any).dataLayer = (window as any).dataLayer || [];

        if (!(window as any).gtag) {
            (window as any).gtag = function () {
                (window as any).dataLayer.push(arguments);
            };
        }

        (window as any).gtag('js', new Date());
        (window as any).gtag('config', GA_MEASUREMENT_ID, {
            page_title: document.title,
            page_location: window.location.href,
            send_page_view: false // We'll handle pageviews manually
        });
    }
};

export const trackPageView = (page_title?: string, page_location?: string) => {
    if (typeof window === 'undefined' || !(window as any).gtag) return;

    (window as any).gtag('event', 'page_view', {
        page_title: page_title || document.title,
        page_location: page_location || window.location.href,
        send_to: GA_MEASUREMENT_ID
    });
};

export const trackEvent = (event_name: string, parameters: Record<string, any> = {}) => {
    if (typeof window === 'undefined' || !(window as any).gtag) return;

    (window as any).gtag('event', event_name, {
        ...parameters,
        send_to: GA_MEASUREMENT_ID
    });
};

export const getClientId = (): Promise<string> => {
    return new Promise((resolve) => {
        if (typeof window === 'undefined' || !(window as any).gtag) {
            resolve('');
            return;
        }

        // Use a different approach to get client ID
        try {
            (window as any).gtag('get', GA_MEASUREMENT_ID, 'client_id', (clientId: string) => {
                resolve(clientId || '');
            });
        } catch (error) {
            console.warn('Failed to get GA4 client ID:', error);
            resolve('');
        }
    });
};